import React, { useRef, useState } from 'react';
import { atom, swr, useAtomCallback, useAtomValue, useExodus } from '@exodus/headless-ui';
import useTrackAssetSwap from '../../hooks/use-track-asset-swap.js';
import { fromAmountAtom, fromAssetAtom, fromWalletAccountAtom, isSendAllAtom, slippageAtom, swapModeAtom, toAmountAtom, toAssetAtom, toWalletAccountAtom, prefillIdAtom, exchangeErrorAtom, preventFromExchangingAtom, canExchangeAtom, isExchangingAtom, quoteAtom, } from '../../../atoms/index.js';
const quoteSWRAtom = swr(quoteAtom);
const isLoadingAtom = atom((get, { selectors }) => {
    const quote = get(quoteSWRAtom);
    const fiatRatesLoading = get(selectors.rates.loading);
    return fiatRatesLoading || quote.loading;
});
const SubmitButton = ({ Component, className, style, onPress }) => {
    const exodus = useExodus();
    const isLoading = useAtomValue(isLoadingAtom);
    const canExchange = useAtomValue(canExchangeAtom);
    const preventFromExchanging = useAtomValue(preventFromExchangingAtom);
    const isExchanging = useAtomValue(isExchangingAtom);
    const [submitting, setSubmitting] = useState(false);
    const submittingRef = useRef(false);
    const trackAnalytic = useTrackAssetSwap();
    const handlePress = useAtomCallback(async (get, set) => {
        const quoteState = get(quoteSWRAtom);
        const currentlyExchanging = get(isExchangingAtom);
        const canSubmit = get(canExchangeAtom);
        const loading = get(isLoadingAtom);
        const quote = quoteState.data;
        if (submittingRef.current || currentlyExchanging || !canSubmit || loading || !quote) {
            return;
        }
        submittingRef.current = true;
        setSubmitting(true);
        exodus.exchange
            .exchange({
            fromAssetName: get(fromAssetAtom).name,
            fromWalletAccount: get(fromWalletAccountAtom).toString(),
            isSendAll: get(isSendAllAtom),
            slippage: get(slippageAtom),
            toAssetName: get(toAssetAtom).name,
            toWalletAccount: get(toWalletAccountAtom).toString(),
            exchangeButton: get(prefillIdAtom),
            swapMode: get(swapModeAtom),
            quote,
        })
            .then(() => {
            set(prefillIdAtom, null);
            set(fromAmountAtom, undefined);
            set(toAmountAtom, undefined);
            void trackAnalytic({ success: true });
        })
            .catch((err) => {
            console.error(err);
            set(exchangeErrorAtom, {
                reason: err.message || 'Exchange failed',
                timestamp: Date.now(),
                quoteId: quote.id,
            });
            void trackAnalytic({ success: false });
        })
            .finally(() => {
            submittingRef.current = false;
            setSubmitting(false);
        });
        void onPress?.();
    }, [exodus.exchange, onPress, trackAnalytic]);
    if (Component) {
        return (React.createElement(Component, { disabled: !canExchange || submitting || isExchanging || isLoading, visible: !preventFromExchanging, loading: isLoading, className: className, style: style, onPress: handlePress }));
    }
    return null;
};
export default SubmitButton;
